import { getterTypes, routesNames } from '@/core/constants'

function montarAbasAdesao(adesao) {
	const abas = []
	abas.push({
		titulo: 'Itens',
		rota: { name: routesNames.ADESAO.ADERENTE.ADESAO_ITENS },
	})

	abas.push({
		titulo: 'Documentos',
		rota: { name: routesNames.ADESAO.ADERENTE.ADESAO_DOCUMENTOS },
	})

	if (adesao.utilizaFluxo) {
		abas.push({
			titulo: 'Ocorrências',
			tabDireita: true,
			rota: { name: routesNames.ADESAO.ACESSAR_OCORRENCIAS_VIEW },
		})

		abas.push({
			titulo: 'Linha do tempo',
			tabDireita: true,
			rota: { name: routesNames.ADESAO.ACESSAR_LINHA_DO_TEMPO_VIEW },
		})
	}

	return abas
}

export default {
	[getterTypes.ADESAO.GET_ABAS_ADESAO]: (state) => montarAbasAdesao(state.informacoesAdesao || {}),
}
